<template>
  <el-dialog title="查看违约金" width="600px" custom-class="import-statement-dialog" v-model="dialog.show" :before-close="closeDialog" :close-on-click-modal='false'>
    <div class="btn-wrap">
      <el-button
        @click="exportFile"
        :loading="exportLoading"
        
      >导出</el-button>
    </div>

    <ab-table
      border
      showOrder
      index-label="序号"
      indexWidth="50"
      maxHeight="226"
      :column-list="columns"
      :table-list="tableData"
      :dataListLoading="tableLoading">
    </ab-table>
    <template #footer>
        <div  class="dialog-footer">
            <div class="sum">合计：￥{{$filters.formatMoney(sumAmount)}}</div>
            <el-button @click="closeDialog">取 消</el-button>
        </div>
    </template>
  </el-dialog>
</template>

<script>

export default {
  name: 'import-statement-dialog',
  props: {
    dialog: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      tableLoading: false,
      exportLoading: false,
      columns: [
        {
          labels: '订单编号',
          props: 'custOrderNo',
          widths: 130
        },
        {
          labels: '违约项目',
          props: 'sourceExpenseItemName',
          widths: 100
        },
        {
          labels: '违约金额',
          props: 'thisCalAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '违约天数',
          props: 'penaltyDays',
          widths: 80
        },
        {
          labels: '违约金',
          props: 'penaltyMoney',
          widths: 100,
          type: 'money',
          align: 'right'
        }
      ],
      tableData: []
    }
  },
  watch: {
    dialog: {
      handler: function (val, oldval) {
        this.queryPenaltyFeeList()
      },
      deep: true
    }
  },
  computed: {
        sumAmount () {
            return this.tableData.map(row => row.penaltyMoney).reduce((acc, cur) => {
                if (!cur) {
                    cur = 0
                }
                return this.$calc.add(cur, acc)
            }, 0)
        }
  },
  mounted () {
    
  },
  methods: {
    queryPenaltyFeeList () {
      if (Object.keys(this.dialog.data).length) {
        let params = {
          customsId: this.dialog.data.customsId,
          coreBillId: this.dialog.data.coreBillId,
          isCurrentAdjustItem: this.dialog.data.isCurrentAdjustItem,
          parentId: this.dialog.data.parentId
        }
        let bizTypes = this.$utils.getSessionStorage('bizType') || {}
        let url = '/sms/importAccounts/queryPenaltyFeeList'
        if (bizTypes.activeIndex == '02') {
           url = '/sms/exportAccounts/queryPenaltyFeeList'
        } 
        this.$post(url, { data: params }, this, 'tableLoading').then(({ data }) => {
          if (data && data.code === 'C0000') {
            let result = data.result || []
            this.tableData = result
          } else {
            this.tableData = []
          }
        })
      } else {
        this.tableData = []
      }
    },

    exportFile () {
      let excelField = this.columns.map(e => e.props)
      let params = Object.assign({}, { data: { interestItemEntryList: this.tableData }, excelField: excelField, colTitleMapList: this.columns })
        let bizTypes = this.$utils.getSessionStorage('bizType') || {}
        let url = '/sms/importAccounts/derivePenaltyFeeExcel'
        if (bizTypes.activeIndex == '02') {
           url = '/sms/exportAccounts/derivePenaltyFeeExcel'
        } 

      this.$post(url, params, this, 'exportLoading').then(({ data }) => {
        if (data && data.code === 'C0000') {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.target = '_blank'
          eleLink.style.display = 'none'
          // 字符内容转变成blob地址
          eleLink.href = data.message
          // 触发点击
          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
        } else {
          this.$message.error(data.message)
        }
      })
    },

    closeDialog () {
      this.dialog.show = false
      this.dialog.data = {}
    }
  }
}
</script>

<style lang="scss">
.import-statement-dialog {
  .btn-wrap {
    margin: -10px 0 10px;
    text-align: right;
  }
  .el-dialog__footer {
    position: relative;
  }
  .sum {
    position: absolute;
    top: -30px;
    left: 0;
    width: 400px;
    height: 42px;
    padding-left: 20px;
    font-size: 16px;
    font-weight: bold;
    line-height: 42px;
    text-align: left;
    color: #FA7F14;
  }
}
</style>
